module.exports = __webpack_public_path__ + "img/case-icon2.3c84ffdb.jpg";